import React, { useContext } from "react";
import ClickOutHandler from "react-clickout-handler";
import { UserContext } from "../../../Context/UserContext";
import { Spinner } from "../../../Reusable/Spinner";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { BaseURL } from "../../../Reusable/BaseURL";

export default function CreateRoleViewModal({
  setViewModal,
  spinner,
  items,
  setViewModalData,
}) {
  const { darkTheme, loginData } = useContext(UserContext);
  function popupCreateIndentOnClickOut() {
    setViewModal(false);
    setViewModalData([]);
  }

  // const IndentApprovalFun = async (id) => {

  //   // const formData= {}
  //   const response = await fetch(`${BaseURL}/purchase/indent/approval/${id}`, {
  //     method: "PATCH",
  //     // body: JSON.stringify(formData),
  //     headers: {
  //       Accept: "application/json",
  //       Authorization: `Bearer ${loginData.token}`,
  //       // "Content-Type": "application/json",
  //     },
  //   });
  // };
  return (
    <div>
      <div className="fixed z-50 top-0 left-0 right-0 bottom-0 backdrop-blur-md bg-[#41414165] flex items-center justify-center ">
        {/* <ClickOutHandler onClickOut={() => popupCreateIndentOnClickOut()}> */}
        <div className="w-full px-4 py-4 md:px-11">
          <button
            className="!border !border-red-500 transition-all p-1.5 gap-1 mb-4 ml-2.5 text-red-500 bg-white rounded-full hover:bg-red-400 hover:text-white"
            onClick={() => popupCreateIndentOnClickOut()}
          >
            <XMarkIcon className="w-5 h-5" />
          </button>
          <div className="flex items-center gap-1">
            {/* <button
              onClick={() => IndentApprovalFun()}
              className="px-4 py-1 bg-red-700 text-white rounded-lg transition-all active:bg-opacity-20"
            >
              Approve
            </button> */}
            <div className="my-3 font-medium text-[18px] !text-black">
              Permissions View
            </div>
          </div>

          <div
            // ref={tableRef}
            // className="scrollBar relative overflow-x-auto shadow-md sm:rounded-lg"
            className="scrollBar relative overflow-x-auto overflow-y-auto sm:rounded-lg h-auto max-h-[77vh]"
          >
            <table
              id="tablePrn"
              className={`w-full text-[11px] uppercase text-left rtl:text-right overflow-x-auto ${
                darkTheme ? "text-gray-500 bg-slate-200" : "text-black bg-white"
              }`}
            >
              <thead
                className={`${
                  darkTheme
                    ? "bg-gray-700 text-gray-400"
                    : "bg-[#47525d] text-white"
                }`}
              >
                <tr>
                <th scope="col" className="px-3 py-3">
                    <div className="flex items-center">
                      Permission
                      <a href="#">
                        <svg
                          className="w-3 h-3 ms-1.5"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                        </svg>
                      </a>
                    </div>
                  </th>
                  <th scope="col" className="px-3 py-3">
                    <div className="flex items-center">
                      S.No.
                      <a href="#">
                        <svg
                          className="w-3 h-3 ms-1.5"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                        </svg>
                      </a>
                    </div>
                  </th>
                  
                </tr>
              </thead>

              <tbody>
                {items.length > 0 ? (
                  items.map((inside, index) => (
                    <tr
                      key={inside.created_at}
                      className={`border-b ${
                        darkTheme ? "bg-gray-800 border-gray-700" : "bg-white "
                      }`}
                    >
                      
                      <td scope="row" className="px-3 py-2 whitespace-nowrap">
                        {inside.name}
                      </td>
                      <td scope="row" className="px-3 py-2 whitespace-nowrap">
                        {index + 1}
                      </td>
                      
                      {/* {index < items.length - 1 && <br />} */}
                    </tr>
                  ))
                ) : spinner ? (
                  <tr
                    className={`border-b ${
                      darkTheme ? "bg-gray-800 border-gray-700" : "bg-white "
                    }`}
                  >
                    <th className="px-3 py-1 text-center" colSpan={3}>
                      <Spinner loading={spinner} />
                    </th>
                  </tr>
                ) : (
                  <tr
                    className={`border-b ${
                      darkTheme ? "bg-gray-800 border-gray-700" : "bg-white "
                    }`}
                  >
                    <th
                      className="px-3 py-1 text-red-500 text-center"
                      colSpan={3}
                    >
                      No record
                    </th>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        {/* </ClickOutHandler> */}
      </div>
    </div>
  );
}
